<app-collapsible-section
  title="Goals (Optional)"
  [isExpanded]="isExpanded"
  [isCompleted]="isCompleted"
  [showDoneButton]="true"
  (toggle)="onBasicInfoToggle($event)"
  (done)="onBasicInfoDone()"
>
  <ng-template #sectionContent>
    <div class="goals-container">
      <!-- Dynamic Goal Sections -->
      <div class="goal-section" *ngFor="let goal of goals; let i = index; trackBy: trackByIndex">
        <div class="goal-header">
          <h3 class="goal-title">Goal {{ i + 1 }}</h3>
          <button
            *ngIf="goals.length > 1"
            class="remove-goal-button"
            (click)="removeGoal(i)"
            type="button"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="#EF4444"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>

        <div class="goal-content">
          <!-- Goal Name -->
          <div class="form-group">
            <label class="form-label">Goal Name<span class="required">*</span></label>
            <input
              type="text"
              class="form-input"
              [class.error]="hasFieldError(i, 'goal_name')"
              placeholder="e.g Black Friday 1000 sales"
              [ngModel]="goal.goal_name"
              (ngModelChange)="onGoalChange(i, 'goal_name', $event)"
              maxlength="150"
              required
            />
            <div class="error-message" *ngIf="hasFieldError(i, 'goal_name')">
              {{ getFieldError(i, 'goal_name') }}
            </div>
          </div>

          <!-- Event Dropdown -->
          <div class="form-group">
            <label class="form-label">Event<span class="required">*</span></label>
            <div class="goal-select" [class.error]="hasFieldError(i, 'event')">
              <mat-select
                [ngModel]="goal.event"
                (ngModelChange)="onGoalChange(i, 'event', $event)"
                placeholder="Select Event"
                panelClass="goal-select-panel"
                disableOptionCentering
                aria-label="Event"
              >
                <mat-option *ngFor="let event of eventOptions" [value]="event.value">{{
                  event.label
                }}</mat-option>
              </mat-select>
            </div>
            <div class="error-message" *ngIf="hasFieldError(i, 'event')">
              {{ getFieldError(i, 'event') }}
            </div>
          </div>

          <!-- Target Value and Timeframe Row -->
          <div class="form-row">
            <!-- Target Value -->
            <div class="form-group">
              <label class="form-label">Target Value<span class="required">*</span></label>
              <input
                type="number"
                class="form-input"
                [class.error]="hasFieldError(i, 'target_value')"
                placeholder="e.g. 1000"
                [ngModel]="goal.target_value"
                (ngModelChange)="onGoalChange(i, 'target_value', $event)"
                (input)="onTargetValueInput(i, $event)"
                (keydown)="onTargetValueKeydown(i, $event)"
                min="0"
                max="9999999"
                required
              />
              <div class="error-message" *ngIf="hasFieldError(i, 'target_value')">
                {{ getFieldError(i, 'target_value') }}
              </div>
            </div>

            <!-- Timeframe -->
            <div class="form-group">
              <label class="form-label">Timeframe<span class="required">*</span></label>
              <div class="goal-select" [class.error]="hasFieldError(i, 'timeframe')">
                <mat-select
                  [ngModel]="goal.timeframe"
                  (ngModelChange)="onGoalChange(i, 'timeframe', $event)"
                  placeholder="Select Timeframe"
                  panelClass="goal-select-panel"
                  disableOptionCentering
                  aria-label="Timeframe"
                >
                  <mat-option
                    *ngFor="let timeframe of timeframeOptions"
                    [value]="timeframe.value"
                    >{{ timeframe.label }}</mat-option
                  >
                </mat-select>
              </div>
              <div class="error-message" *ngIf="hasFieldError(i, 'timeframe')">
                {{ getFieldError(i, 'timeframe') }}
              </div>
            </div>
          </div>

          <!-- Custom Duration Date Pickers -->
          <div class="form-row" *ngIf="goal.timeframe === 'custom-duration'">
            <!-- Start Date -->
            <ng-container
              *ngTemplateOutlet="
                goalDatePicker;
                context: {
                  label: 'Start Date',
                  fieldName: 'start_date',
                  placeholder: 'Select Start Date',
                  goalValue: goal.start_date,
                  idx: i,
                }
              "
            ></ng-container>

            <!-- End Date -->
            <ng-container
              *ngTemplateOutlet="
                goalDatePicker;
                context: {
                  label: 'End Date',
                  fieldName: 'end_date',
                  placeholder: 'Select End Date',
                  goalValue: goal.end_date,
                  idx: i,
                }
              "
            ></ng-container>
          </div>
        </div>
      </div>

      <!-- Add Another Goal Button -->
      <div class="add-goal-container">
        <button class="add-goal-button" (click)="addAnotherGoal()">
          <span class="add-goal-text">Add another goal</span>
          <svg
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1075_219870)">
              <path
                d="M8.17742 6.32258V0.677419C8.17742 0.497757 8.10605 0.325452 7.97901 0.198411C7.85197 0.0713707 7.67966 0 7.5 0C7.32034 0 7.14803 0.0713707 7.02099 0.198411C6.89395 0.325452 6.82258 0.497757 6.82258 0.677419V6.32258H1.17742C0.997757 6.32258 0.825452 6.39395 0.698411 6.52099C0.571371 6.64803 0.5 6.82034 0.5 7C0.5 7.17966 0.571371 7.35197 0.698411 7.47901C0.825452 7.60605 0.997757 7.67742 1.17742 7.67742H6.82258V13.3226C6.82492 13.5015 6.89704 13.6725 7.02358 13.799C7.15012 13.9255 7.32106 13.9977 7.5 14C7.67966 14 7.85197 13.9286 7.97901 13.8016C8.10605 13.6745 8.17742 13.5022 8.17742 13.3226V7.67742H13.8226C14.0022 7.67742 14.1745 7.60605 14.3016 7.47901C14.4286 7.35197 14.5 7.17966 14.5 7C14.4977 6.82106 14.4255 6.65012 14.299 6.52358C14.1725 6.39704 14.0015 6.32492 13.8226 6.32258H8.17742Z"
                fill="#555963"
              />
            </g>
            <defs>
              <clipPath id="clip0_1075_219870">
                <rect width="14" height="14" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>

      <div class="form-footer">
        <button class="btn btn-primary btn-medium" (click)="onBasicInfoDone()">Done</button>
      </div>
    </div>
  </ng-template>
</app-collapsible-section>

<!-- Goal Date Picker Template (reused for start and end date fields) -->
<ng-template
  #goalDatePicker
  let-label="label"
  let-fieldName="fieldName"
  let-placeholder="placeholder"
  let-goalValue="goalValue"
  let-i="idx"
>
  <div class="form-group">
    <label class="form-label">{{ label }}<span class="required">*</span></label>
    <mat-datepicker
      [ngModel]="goalValue"
      (ngModelChange)="onDateChange(i, fieldName, $event)"
      dateFormat="M d, yy"
      [class]="getStyleClass('custom-date-picker', i, fieldName)"
    >
      <ng-template pTemplate="inputicon">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M12 2.66667H11.3333V2C11.3333 1.63181 11.0349 1.33333 10.6667 1.33333C10.2985 1.33333 10 1.63181 10 2V2.66667H6V2C6 1.63181 5.70152 1.33333 5.33333 1.33333C4.96514 1.33333 4.66667 1.63181 4.66667 2V2.66667H4C3.26362 2.66667 2.66667 3.26362 2.66667 4V12C2.66667 12.7364 3.26362 13.3333 4 13.3333H12C12.7364 13.3333 13.3333 12.7364 13.3333 12V4C13.3333 3.26362 12.7364 2.66667 12 2.66667ZM12 12H4V6H12V12Z"
            fill="#6B7280"
          />
        </svg>
      </ng-template>
    </mat-datepicker>
    <svg
      class="caleder-icon"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.39844 7.42812C1.39844 4.78826 1.39844 3.46833 2.21854 2.64823C3.03864 1.82812 4.35857 1.82812 6.99844 1.82812C9.6383 1.82812 10.9582 1.82812 11.7783 2.64823C12.5984 3.46833 12.5984 4.78826 12.5984 7.42812C12.5984 10.068 12.5984 11.3879 11.7783 12.208C10.9582 13.0281 9.6383 13.0281 6.99844 13.0281C4.35857 13.0281 3.03864 13.0281 2.21854 12.208C1.39844 11.3879 1.39844 10.068 1.39844 7.42812Z"
        stroke="#6B7280"
        stroke-width="1.5"
      />
      <path
        d="M9.33594 0.818359V3.15169"
        stroke="#6B7280"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66406 0.818359V3.15169"
        stroke="#6B7280"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.75 5.13281H12.25"
        stroke="#6B7280"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <div class="error-message" *ngIf="hasFieldError(i, fieldName)">
      {{ getFieldError(i, fieldName) }}
    </div>
  </div>
</ng-template>
